/**
 * What the file connector contributes to the route tree.
 *
 * One route, in the integration group's own heading — `integration:group` is a
 * *string*, not an import, so the two features share a heading without sharing
 * code. That is deliberate: two headings both reading "Intégration" would be
 * the alternative, and a reader would wonder what the difference is.
 *
 * The permission is the contract's, not one of this connector's own: importing
 * a file writes through the contract, so whoever may decide which side owns a
 * field is the person who may push a file.
 */

import type { ApiClient } from "@hardauto/core-api";
import type { FeatureRoutes } from "@hardauto/core-router";

import { ExchangeScreen } from "./screens/ExchangeScreen";
import { CONNECTOR_FILES_PATHS } from "./paths";
import "./i18n";

export function connectorFilesRoutes(client: ApiClient): FeatureRoutes {
  function Exchange() {
    return <ExchangeScreen client={client} />;
  }

  return {
    id: "connector_files",
    routes: [
      {
        path: CONNECTOR_FILES_PATHS.exchange,
        component: Exchange,
        layout: "app",
        requirement: { authenticated: true, permissions: ["integration.journal.read"] },
        nav: {
          group: "integration:group",
          labelKey: "connectorFiles:nav.exchange",
          section: "main",
          order: 73,
        },
      },
    ],
  };
}
